// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__oXdm6","options":"AnswerScale_options__ln0o0","selected":"AnswerScale_selected__3Pgwl"};